import { createSlice } from '@reduxjs/toolkit';
import {
  fetchJobChatLiveAgentDetails,
  fetchJobChatDetails,
  fetchUnclaimedChats,
  claimJobChat,
} from '../actions';

const initialState = {
  isLoading: true,
  page: 1,
  chatsCount: 0,
  chats: [],
  agentsCount: 0,
  isAgentsDetailsLoading: false,
  agents: [],
  unClaimedChats: [],
  unClaimedChatsLoading: false,
};

const handleClaimChat = (state, action) => {
  const { payload } = action;
  const { unClaimedChats } = state;

  const existingChatIndex = unClaimedChats.findIndex((chat) => chat.threadId === payload.thread.id);

  if (existingChatIndex !== -1) {
    const userLeftChats = unClaimedChats.slice(0, existingChatIndex);
    const userRightChats = unClaimedChats.slice(existingChatIndex + 1);

    return userLeftChats.concat(userRightChats);
  }

  return unClaimedChats;
};

const getAgents = (agents = []) => {
  const userNames = {};

  return agents.filter((agent) => {
    if (agent.userName in userNames) {
      return false;
    }

    userNames[agent.userName] = true;

    return true;
  });
};

const jobChatSlice = createSlice({
  name: 'JobChatDetails',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(fetchJobChatDetails.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchJobChatDetails.fulfilled, (state, action) => {
      const { page, items } = action.payload.paging;
      state.chats = action.payload.chats || [];
      state.isLoading = false;
      state.page = page;
      state.chatsCount = items;
    });

    builder.addCase(fetchJobChatDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchJobChatLiveAgentDetails.pending, (state) => {
      state.isAgentsDetailsLoading = true;
    });

    builder.addCase(fetchJobChatLiveAgentDetails.fulfilled, (state, action) => {
      const { page, items } = action.payload.paging;

      state.agents = getAgents(action.payload.agents);
      state.isAgentsDetailsLoading = false;
      state.page = page;
      state.agentsCount = items;
    });

    builder.addCase(fetchJobChatLiveAgentDetails.rejected, (state, action) => {
      state.isAgentsDetailsLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchUnclaimedChats.pending, (state) => {
      state.unClaimedChatsLoading = true;
    });

    builder.addCase(fetchUnclaimedChats.fulfilled, (state, action) => {
      state.unClaimedChats = action.payload.chats || [];
      state.unClaimedChatsLoading = false;
    });

    builder.addCase(fetchUnclaimedChats.rejected, (state, action) => {
      state.error = action.error;
      state.unClaimedChatsLoading = false;
    });

    builder.addCase(claimJobChat.pending, (state) => {
      state.unClaimedChatsLoading = true;
    });

    builder.addCase(claimJobChat.fulfilled, (state, action) => {
      state.unClaimedChats = handleClaimChat(state, action);
      state.unClaimedChatsLoading = false;
    });

    builder.addCase(claimJobChat.rejected, (state, action) => {
      state.error = action.payload.error;
    });
  },
});

export default jobChatSlice;
